import React, { useState } from "react";
import axios from "axios";
import { serviceConfig } from "configs";
import OrdersTable from "components/OrderTable/OrdersTable"; // For DGH
import DIHTable from "components/DIHTable/DIHTable"; // For DIH
import RadioButton from "common/RadioButton/RadioButton";
import { Input } from "common/Input/Input";
import { Button } from "common/Button/Button";
import DatePicker from "common/DatePicker/DatePicker";
import { Htag } from "common/Htag/Htag";
import { Select } from "common/Select/Select";
import { SelectItem } from "common/Select/SelectItem";
import { P } from "common/P/P";
import IGHTable from "components/IGHTable/IGHTable";

const AdvancedFilterPage = () => {
	const [documentType, setDocumentType] = useState("DGH");
	const [filterCriteria, setFilterCriteria] = useState<any>({});
	const [filteredResults, setFilteredResults] = useState([]);
	const [receivedDate, setReceivedDate] = useState("");
	const [sentDate, setSentDate] = useState("");

	const handleDocumentTypeChange = (e: any) => {
		setDocumentType(e.target.value);
		setFilterCriteria({});
		setFilteredResults([]);
	};

	const handleInputChange = (e: any) => {
		setFilterCriteria({
			...filterCriteria,
			[e.target.name]: e.target.value,
		});
	};

	const formatDateForBackend = (dateString: string) => {
		const parts = dateString.split(".");
		if (parts.length === 3) {
			return `${parts[2]}-${parts[1]}-${parts[0]}`; // Converts DD.MM.YYYY to YYYY-MM-DD
		}
		return dateString; // Return original string if not in expected format
	};

	const handleDateChange = (date: any, name: any) => {
		const formattedDate = formatDateForBackend(date);
		if (name === "receivedDate") {
			setReceivedDate(formattedDate);
		} else if (name === "sentDate") {
			setSentDate(formattedDate);
		}
		setFilterCriteria({
			...filterCriteria,
			[name]: formattedDate,
		});
	};

	const handleSubmit = async () => {
		try {
			const response = await axios.post(
				`${serviceConfig.apiUrl}/filter/${documentType}`,
				filterCriteria
			);
			setFilteredResults(response.data.data);
		} catch (error) {
			console.error("Error fetching filtered data:", error);
		}
	};

	const resetFilters = () => {
		setFilterCriteria({
			typeSide: "", // Resetting radio buttons
			fromWhere: "",
			fromWho: "",
			sentNumber: "",
			receivedNumber: "",
			note: "",
			tags: "",
			letterType: "", // Assuming these are all the fields in filterCriteria
		});
		setFilteredResults([]);
		setReceivedDate(""); // Resetting date pickers
		setSentDate("");
	};

	const handleSelect = (value: any) => {
		setFilterCriteria((prevState: any) => ({
			...prevState,
			letterType: value,
		}));
	};
	return (
		<div className="grid grid-flow-row auto-rows-max gap-6 px-6 py-6 min-h-[90vh]">
			<div className="grid grid-cols-1 gap-2">
				<Htag tag="h2" type="medium" className="text-mainColor">
					Resminamanyň görnüşi
				</Htag>
				<div className="grid gap-6 grid-cols-maxFour">
					<RadioButton
						name="documentType"
						value="DGH"
						label="Daşarky gelen resminamalar"
						checked={documentType === "DGH"}
						onChange={handleDocumentTypeChange}
						id="DGH"
					/>
					<RadioButton
						name="documentType"
						value="DIH"
						label="Daşarky iberilen resminamalar"
						checked={documentType === "DIH"}
						onChange={handleDocumentTypeChange}
						id="DIH"
					/>
					<RadioButton
						name="documentType"
						value="IGH"
						label="Içerki gelen resminamalar"
						checked={documentType === "IGH"}
						onChange={handleDocumentTypeChange}
						id="IGH"
					/>
					<RadioButton
						name="documentType"
						value="IIH"
						label="Içerki iberilen resminamalar"
						checked={documentType === "IIH"}
						onChange={handleDocumentTypeChange}
						id="IIH"
					/>
				</div>
			</div>

			{documentType === "DGH" && (
				<div className="grid grid-flow-row grid-cols-1 gap-6 auto-rows-max">
					{/* Type Side Radio Buttons */}
					<div className="grid grid-flow-row grid-cols-1 gap-4 auto-rows-max">
						<P size="t1" type="regular">
							Tarapyň görnüşi
						</P>
						<div className="grid gap-6 grid-cols-maxTwo">
							<RadioButton
								id="administrative"
								name="typeSide"
								value="Administrative"
								label="Edara görnüşli tarap"
								onChange={handleInputChange}
								checked={filterCriteria.typeSide === "Administrative"}
							/>
							<RadioButton
								id="personal"
								name="typeSide"
								value="Personal"
								label="Şahsy tarap"
								onChange={handleInputChange}
								checked={filterCriteria.typeSide === "Personal"}
							/>
						</div>
					</div>

					{/* Other Input Fields */}
					<div className="grid grid-cols-3 gap-4 TwoXl:grid-cols-4">
						{/* Select for Letter Type */}
						<Select
							label="Hatyň görnüşi"
							value={filterCriteria.letterType}
							onSelect={(value) => handleSelect(value)}
							defaultSelectLabel=""
						>
							<SelectItem value="Arza">Arza</SelectItem>
							<SelectItem value="Şertnama">Şertnama</SelectItem>
							<SelectItem value="Tender">Tender</SelectItem>
							<SelectItem value="Şertnama">Şertnama</SelectItem>
						</Select>
						<Input
							appearance="default"
							type="text"
							name="fromWhere"
							withlabel={true}
							label="Nireden gelen"
							value={filterCriteria.fromWhere || ""}
							onChange={handleInputChange}
						/>
						<Input
							appearance="default"
							type="text"
							name="fromWho"
							withlabel={true}
							label="Kimden gelen"
							value={filterCriteria.fromWho || ""}
							onChange={handleInputChange}
						/>
						<Input
							appearance="default"
							type="text"
							name="sentNumber"
							withlabel={true}
							label="Iberilen belgisi"
							value={filterCriteria.sentNumber || ""}
							onChange={handleInputChange}
						/>
					</div>

					<div className="grid grid-cols-3 gap-4 TwoXl:grid-cols-4">
						{/* DatePickers */}
						<DatePicker
							label="Iberilen senesi"
							value={sentDate}
							onDateChange={(date) => handleDateChange(date, "sentDate")}
						/>
						<DatePicker
							label="Gelen senesi"
							value={receivedDate}
							onDateChange={(date) => handleDateChange(date, "receivedDate")}
						/>
						<Input
							appearance="default"
							type="text"
							name="receivedNumber"
							withlabel={true}
							label="Kabul ediş belgisi"
							value={filterCriteria.receivedNumber || ""}
							onChange={handleInputChange}
						/>
						<Input
							appearance="default"
							type="text"
							name="note"
							withlabel={true}
							label="Gysgaça beýany"
							value={filterCriteria.note || ""}
							onChange={handleInputChange}
						/>
					</div>
				</div>
			)}

			{documentType === "DIH" && (
				<div className="grid grid-flow-row grid-cols-1 gap-4 auto-rows-max">
					<P size="t1" type="regular">
						Tarapyň görnüşi
					</P>
					<div className="grid gap-6 grid-cols-maxTwo">
						<RadioButton
							id="administrativeDIH"
							name="typeSide"
							value="Administrative"
							label="Edara görnüşli tarap"
							onChange={handleInputChange}
							checked={filterCriteria.typeSide === "Administrative"}
						/>
						<RadioButton
							id="personalDIH"
							name="typeSide"
							value="Personal"
							label="Şahsy tarap"
							onChange={handleInputChange}
							checked={filterCriteria.typeSide === "Personal"}
						/>
					</div>
					<div className="grid grid-cols-3 gap-4 TwoXl:grid-cols-4">
						<Select
							label="Hatyň görnüşi"
							onSelect={handleSelect} // Ensure you define this function
							defaultSelectLabel=""
							value={filterCriteria.letterType || ""}
						>
							<SelectItem value="Arza">Arza</SelectItem>
							<SelectItem value="Şertnama">Şertnama</SelectItem>
							<SelectItem value="Tender">Tender</SelectItem>
							<SelectItem value="Şertnama">Şertnama</SelectItem>
						</Select>
						<Input
							appearance="default"
							type="text"
							name="toWhere"
							withlabel={true}
							label="Nirä ugradylýar"
							value={filterCriteria.toWhere || ""}
							onChange={handleInputChange}
						/>
						<DatePicker
							label="Senesi"
							onDateChange={(date) => handleDateChange(date, "sentDate")}
							value={sentDate}
						/>
						<Input
							appearance="default"
							type="text"
							name="note"
							withlabel={true}
							label="Gysgaça beýany"
							value={filterCriteria.note || ""}
							onChange={handleInputChange}
						/>
					</div>
				</div>
			)}

			{documentType === "IGH" && (
				<div className="grid grid-cols-3 gap-4 TwoXl:grid-cols-4">
					<DatePicker
						label="Senesi"
						onDateChange={(date) => handleDateChange(date, "sentDate")}
						value={sentDate}
					/>
					<Input
						appearance="default"
						type="text"
						name="note"
						withlabel={true}
						label="Gysgaça beýany"
						value={filterCriteria.note || ""}
						onChange={handleInputChange}
					/>
				</div>
			)}

			{documentType === "IIH" && (
				<div className="grid grid-cols-3 gap-4 TwoXl:grid-cols-4">
					<DatePicker
						label="Senesi"
						onDateChange={(date) => handleDateChange(date, "sentDate")}
						value={sentDate}
					/>
					<Input
						appearance="default"
						type="text"
						name="note"
						withlabel={true}
						label="Gysgaça beýany"
						value={filterCriteria.note || ""}
						onChange={handleInputChange}
					/>
				</div>
			)}

			<div className="grid gap-4 grid-cols-maxTwo place-items-center place-content-end">
				<Button onClick={resetFilters} appearance="ghost">
					Täzelemek
				</Button>

				<Button onClick={handleSubmit} appearance="main">
					Filter
				</Button>
			</div>

			{documentType === "DGH" &&
				(filteredResults.length > 0 ? (
					<OrdersTable orders={filteredResults} type="dgh" />
				) : (
					<P size="p3" type="medium">
						Daşarky gelen resminalar filteri boýunça hiç zat tapylmady!
					</P>
				))}
			{documentType === "DIH" &&
				(filteredResults.length > 0 ? (
					<DIHTable orders={filteredResults} type="dih" />
				) : (
					<P size="p3" type="medium">
						Daşarky iberilen resminalar filteri boýunça hiç zat tapylmady!
					</P>
				))}

			{documentType === "IGH" &&
				(filteredResults.length > 0 ? (
					<IGHTable orders={filteredResults} type="igh" />
				) : (
					<P size="p3" type="medium">
						Içerki gelen resminalar filteri boýunça hiç zat tapylmady!
					</P>
				))}
			{documentType === "IIH" &&
				(filteredResults.length > 0 ? (
					<IGHTable orders={filteredResults} type="iih" />
				) : (
					<P size="p3" type="medium">
						Içerki iberilen resminalar filteri boýunça hiç zat tapylmady!
					</P>
				))}
		</div>
	);
};

export default AdvancedFilterPage;
